import api from "../../apiConfig/apiConfig"
import {
    Post,
    Get,
    Patch,
    Put,
    Delete
} from '../base/baseAjax'
export function getTaskFlowDetail(id) {
    return Get({
        url: api.taskflow.getTaskFlowDetail + id,
    })
}
export function changeTaskFlowStatus(id) {
    return Patch({
        url: api.taskflow.changeTaskFlowStatus + id
    })
}
export function addTaskFlow(param) {
    return Post({
        url: api.taskflow.addTaskFlow,
        bodyParam: param
    })
}
export function editTaskFlow(id, param) {
    return Put({
        url: api.taskflow.editTaskFlow + id,
        bodyParam: param
    })
}
export function getTaskRuleList(param) {
    return Post({
        url: api.taskflow.getTaskRuleList,
        UrlParam: param
    })
}
export function addTaskRule(param) {
    return Post({
        url: api.taskflow.addTaskRule,
        bodyParam: param
    })
}
export function editTaskRule(id, param) {
    return Patch({
        url: api.taskflow.editTaskRule + id,
        bodyParam: param

    })
}
export function deleteTaskRule(id) {
    return Delete({
        url: api.taskflow.deleteTaskRule + id,
    })
}
export function getTaskRuleDetail(id) {
    return Get({
        url: api.taskflow.getTaskRuleDetail + id
    })
}
export function getTaskGroup() {
    return Post({
        url: api.taskflow.getTaskGroup
    })
}
export function addTaskGroup(param) {
    return Post({
        url: api.taskflow.addTaskGroup,
        bodyParam: param
    })
}
export function deleteTaskGroup(id) {
    return Delete({
        url: api.taskflow.deleteTaskGroup + id
    })
}
export function editTaskGroup(id, param) {
    return Patch({
        url: api.taskflow.editTaskGroup + id,
        bodyParam: param
    })
}
export function changeTaskRuleOrder(id, param) {
    return Put({
        url: api.taskflow.changeTaskRuleOrder + id,
        bodyParam: param
    })
}

export function newAutoTrigger(param) {
    return Post({
        url: api.taskflow.newAutoTrigger,
        bodyParam: param
    })
}

export function autoTriggerDetail(param) {
    return Get({
        url: api.taskflow.autoTriggerDetail + param
    })
}
export function deleteAutoTrigger(param) {
    return Delete({
        url: api.taskflow.deleteAutoTrigger + param
    })
}
export default {
    getTaskFlowDetail,
    changeTaskFlowStatus,
    addTaskFlow,
    editTaskFlow,
    getTaskRuleList,
    addTaskRule,
    editTaskRule,
    deleteTaskRule,
    getTaskRuleDetail,
    getTaskGroup,
    addTaskGroup,
    deleteTaskGroup,
    editTaskGroup,
    changeTaskRuleOrder,
    newAutoTrigger,
    autoTriggerDetail,
    deleteAutoTrigger
}